module.exports = __webpack_public_path__ + "static/media/doctor_patientcall.58c61e92.webp";